<template>
    <div>
        <router-link :to="to" exact :style="{ backgroundColor: getBrandColor }">{{ text }} ></router-link>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: {
        to: {
            type: Object | String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getBrandColor: "brand/getLinksColor"
        })
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes.scss";
a {
    display: inline-block;
    text-decoration: none;
    padding: 3px 10px;
    border-radius: 50px;
    color: #fff;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// LinkButton.vue?8bd6aec6